import { render } from "preact";
import { App } from "./App";

render(<App />, document.getElementById("app")!);

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/service-worker.js").catch(() => {
    // Offline shell should still launch if registration fails.
  });
}
